module.exports = __webpack_public_path__ + "static/media/WEX-USDT.337f5f3a.png";